import { Autosuggest, AutosuggestRemoteOptions } from "@interface48/form-controls";
import React from "react";
import { getSchemaOptions, processValue } from "../utils";
import { WidgetProps } from "./models";

interface AutosuggestWidgetProps extends WidgetProps<string> {
  options: {
    emptyValue?: string;
    remoteOptions?: AutosuggestRemoteOptions;
  };
}

export const AutosuggestWidgetComponent = (props: AutosuggestWidgetProps) => {
  const { id, schema, required, placeholder, value, options: uiOptions, formContext, onChange } = props;
  const { emptyValue, remoteOptions } = uiOptions;

  const processAutosuggestValue = (value: string | null | undefined) => {
    return processValue(value, schema.type, required) as string | null | undefined;
  };

  return (
    <Autosuggest
      id={id}
      label={schema.title}
      placeholder={placeholder}
      value={typeof value === "undefined" && emptyValue ? emptyValue : value}
      options={!remoteOptions ? getSchemaOptions<string>(schema) : undefined}
      remoteOptions={remoteOptions}
      getApiConfiguration={formContext && formContext.getApiConfiguration}
      processValue={processAutosuggestValue}
      onChange={onChange}
    />
  );
};

export const AutosuggestWidget = AutosuggestWidgetComponent;
